export default [
  {
    title: 'จัดการคำขอ ถอนเงิน',
    route: 'withdraw-management',
    icon: 'PocketIcon',
    action: 'all',
    resource: 'admin',
  },
]
